module.exports = __webpack_public_path__ + "img/2021.16e9b38b.jpg";